import { useNavigate } from 'react-router';
import { DASHBOARD } from '@/constants/routes';
import { saveToken } from '@/services/jwt';
import { LOGIN_MUTATION } from '@/api/mutations';
import { LoginData } from './LoginForm';
import { useApolloClient, useMutation } from '@apollo/client';
import { restartGraphqlWsConnection } from '@/api/apollo';

const useLoginRequest = () => {
    const navigate = useNavigate();
    const apolloClient = useApolloClient();
    const [ login ] = useMutation(LOGIN_MUTATION)


    const handleLogin = async (values: LoginData, setError: (error: string) => void) => {

        const req = await login({ variables: values });

        if (req.data?.login?.message) {
            if (req.data.login.__typename == "ErrorType") return setError(req.data?.login?.message);

            saveToken(req.data.login.message);
            restartGraphqlWsConnection();


            apolloClient.cache.evict({ id: 'ROOT_QUERY', fieldName: 'me' });
            apolloClient.cache.gc();
            await apolloClient.refetchQueries({ include: 'active' });

            return navigate(DASHBOARD);
            
        }

        req.errors && setError(req.errors.toString())
    }

    return {
        login: handleLogin
    }
}

export default useLoginRequest;